export default function SwitchIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#47485D" />
      <path
        d="M13.7812 5.46875C14 5.28125 14.3125 5.28125 14.5 5.5C14.6875 5.65625 14.7188 5.96875 14.5625 6.15625L11.3438 10.6562L16.7188 11.1875C17.3125 11.25 17.5312 11.9688 17.125 12.3438L10.2188 18.5312C10 18.7188 9.6875 18.7188 9.5 18.5C9.3125 18.3438 9.28125 18.0312 9.4375 17.8438L12.6562 13.3438L7.28125 12.8125C6.6875 12.75 6.46875 12.0312 6.875 11.6562L13.7812 5.46875Z"
        fill="#FFB800"
      />
    </svg>
  );
}
